import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    UserStoreService,
    VehicleType,
} from '@polaris-customerweb/sharedcomponents.core';
import { LayerVisibilityState } from './layer-visibility.reducer';

@Injectable({
    providedIn: 'root',
})
export class LayerVisibilityService {
    rideType: VehicleType;
    constructor(
        private configService: ConfigService,
        private userStoreService: UserStoreService
    ) {}

    save(state: LayerVisibilityState) {
        this.userStoreService.set(
            `${this.configService.appSku}_layerVisibility`,
            JSON.stringify(state)
        );
    }

    read() {
        return JSON.parse(
            this.userStoreService.get(
                `${this.configService.appSku}_layerVisibility`
            ) || ''
        ) as LayerVisibilityState;
    }
}
